export default __webpack_public_path__ + "static/media/OMEGA Engineering.5cb9ade6.png";